import Dialog from '@/components/_custom/Dialog/Dialog'
import DialogHeader from '@/components/_custom/DialogHeader/DialogHeader'
import DialogBody from '@/components/_custom/DialogBody/DialogBody'
import styles from './showQRCodeDialog.module.scss'
import QRCode from 'react-qr-code'
import { FunctionComponent, RefObject, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import ButtonTextIcon from '@/components/_custom/Buttons/ButtonTextIcon/ButtonTextIcon'
import { PictureAsPdf, Save } from '@mui/icons-material'
import { useCommunicationKitPdf } from './useCommunicationKitPdf'

interface ShowQRCodeDialogProps {
    open: boolean
    onClose: () => void
    autoLink: string
    pdfVariant: 'eaje' | 'rpe' | 'staff'
    daycareName?: string
    daycareLogoBase64Data?: string
}

const ShowQRCodeDialog: FunctionComponent<ShowQRCodeDialogProps> = ({
    open,
    onClose,
    autoLink,
    pdfVariant,
    daycareName,
    daycareLogoBase64Data
}: ShowQRCodeDialogProps) => {
    const { t } = useTranslation()

    const qrCodeContainerRef: RefObject<HTMLDivElement | null> = useRef<HTMLDivElement>(null)
    const qrCodeExactRef: RefObject<HTMLDivElement | null> = useRef<HTMLDivElement>(null)

    const { handleSaveToPng, handleDownloadPdf } = useCommunicationKitPdf({
        pdfVariant,
        daycareName,
        daycareLogoBase64Data,
        qrContainerRef: qrCodeContainerRef,
        qrExactRef: qrCodeExactRef
    })

    return (
        <Dialog open={open} handleClose={onClose}>
            <DialogHeader title={t('myQRCode')}></DialogHeader>
            <DialogBody className={styles.DialogBody}>
                <div ref={qrCodeContainerRef} className={styles.QRCode}>
                    <div ref={qrCodeExactRef} style={{ width: 256, height: 256 }}>
                        <QRCode value={autoLink} size={256} bgColor='#FFFFFF' fgColor='#000000' level='L' />
                    </div>
                </div>
                <div className={styles.ButtonContainer}>
                    <ButtonTextIcon
                        type={'custom'}
                        onClick={handleSaveToPng}
                        customText={t('save')}
                        customIcon={<Save />}
                        className={styles.Button}
                    />
                </div>
                <div className={styles.ButtonContainer}>
                    <ButtonTextIcon
                        type={'custom'}
                        onClick={() => handleDownloadPdf('flyers')}
                        customText={t('downloadFlyers')}
                        customIcon={<PictureAsPdf />}
                        className={styles.Button}
                    />
                    <ButtonTextIcon
                        type={'custom'}
                        onClick={() => handleDownloadPdf('affiche')}
                        customText={t('downloadAffiche')}
                        customIcon={<PictureAsPdf />}
                        className={styles.Button}
                    />
                </div>
                <div className={styles.ButtonContainer}>
                    <ButtonTextIcon type={'return'} onClick={onClose} className={styles.Button} />
                </div>
            </DialogBody>
        </Dialog>
    )
}

export default ShowQRCodeDialog
